import React from 'react'

import BotaoCTA from '../BotaoCTA'
import PropTypes from 'prop-types'
import { ContainerParagraph } from '../RichText/styles'
import { Link as LinkDS } from 'veloe-ds'
import ReactMarkdown from 'react-markdown'
import useMedia from 'use-media'
import { DescricaoContainer, Descricao, Extra, Sorriso, BotaoInferior } from './styles'
import { TituloPrincipal } from './tituloPrincipal'

export default function TituloDestaque(props) {
  const { titulo } = props
  const { containerPadding } = props
  const hidden = titulo.hidden

  const isMobile = useMedia({
    maxWidth: 991,
  })

  const hideInDesktop = !isMobile ? hidden : ''

  return (
    <>
      <TituloPrincipal
        containerPadding={containerPadding}
        listaDeCardsLength={props.listaDeCardsLength}
        titulo={titulo}
        ignoreH1={props.ignoreH1}
      />
      {titulo.iconeSorriso !== 'none' && (
        <Sorriso dark={titulo.iconeSorriso === 'dark'} />
      )}
      {titulo.descricao && (
        <DescricaoContainer>
          <Descricao
            tamanho={
              titulo.tamanhoDoTtulo ? titulo.tamanhoDoTtulo : 'Grande'
            }
          >
            <ReactMarkdown>{titulo.descricao}</ReactMarkdown>
          </Descricao>
        </DescricaoContainer>
      )}

      {titulo.conteudoExtra && (
          <Extra largeWidth={titulo.largeWidth}>
            {/*documentToReactComponents(
              titulo.conteudoExtra.json,
              options
            )*/}
            <ContainerParagraph largeWidth={titulo.largeWidth}>
              {JSON.stringify(titulo.conteudoExtra)}
            </ContainerParagraph>
          </Extra>
        )}
      {titulo.botao && (
        <BotaoInferior buttonPosition={titulo.buttonPosition} hidden={hideInDesktop}>
          <BotaoCTA botao={titulo.botao} external={titulo.botao.external} />
        </BotaoInferior>
      )}
      {titulo.link && (
        <a href={titulo.link.rota.endereco} passHref>
          <LinkDS> {titulo.link.label} </LinkDS>
        </a>
      )}
    </>
  )
}

TituloDestaque.propTypes = {
  titulo: PropTypes.shape({
    botao: PropTypes.shape({
      name: PropTypes.string,
    }),
    corDeFundo: PropTypes.string,
    descricao: PropTypes.string,
    iconeSorriso: PropTypes.string,
    tamanhoDoTtulo: PropTypes.string,
    titulo: PropTypes.string,
    listaDeCardsLength: PropTypes.string,
  }),
}
